<template>
	<!-- Animated checkbox, to be used when a fancier checkbox is needed. -->
	<label
		:class="[
			'checkbox-wrap',
			checkboxClasses,
		]"
		@change="onChange"
		@click="onClick"
	>
		<input type="checkbox" :checked="checked" :name="name" :id="name">
		<span :class="['checkbox', { checked }]">
			<span v-if="value" class="checkmark" />
		</span>
		<span class="checkbox-label">
			<slot v-if="labelSlot" />
			<template v-else>
				{{ label }}
			</template>
		</span>
		<span v-if="filterCount !== null && filterCount !== undefined" class="checkbox-count">
			({{ filterCount }})
		</span>
	</label>

</template>
<script>
export default {
	props: {
		value: {
			type: Boolean,
			default: false,
		},
		// Use label for simple text label, or labelSlot for a more complex label with ex. price etc
		label: {
			type: String,
			required: false,
		},
		labelSlot: {
			type: Boolean,
			required: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		// When checkbox requires confirmation in parent before being checked. example insurance
		requireConfirmation: {
			type: Boolean,
			default: false,
		},
		small: {
			type: Boolean,
			default: false,
		},
		picker: {
			type: Boolean,
			default: false,
		},
		dark: {
			type: Boolean,
			default: false,
		},
		filterCount: {
			type: Number,
			default: null,
			required: false,
		},
		// Can be used if field requires extra label info
		name: {
			type: String,
			required: false,
		},
	},
	data () {
		return {
			checked: this.value,
		};
	},
	computed: {
		checkboxClasses () {
			return [
				{
					'_disabled': this.disabled,
					'_checked': this.checked,
					'_small': this.small,
					'_picker': this.picker,
					'_dark': this.dark,
				},
			];
		},
	},
	methods: {
		onChange () {
			if (this.disabled || this.requireConfirmation) {
				return;
			}

			this.checked = ! this.checked;
		},
		// When click event is in need of confirmation in parent
		onClick (event) {
			if (this.requireConfirmation) {
				this.$emit('click');
				event.preventDefault();
			}
		},
	},
	watch: {
		checked (to) {
			if (to !== this.value) {
				this.$emit('input', to);
			}
		},
		value (checked) {
			this.checked = checked;
		},
	},
};
</script>